import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

export const insuranceInitialStore = {
  idCotacao: "",
  valorPremio: 0,
  dataCotacao: "",
  isInsuranceHired: false,
  termsAcceptDate: "",
  termsVersion: "1.0.0",
};

export const useInsuranceStore = create()(
  immer(
    devtools(
      (set) => ({
        ...insuranceInitialStore,
        setInsurance: (value, type) => {
          set(
            (state) => {
              state[type] = value;
            },
            false,
            `setInsurance - ${type}`
          );
        },
      }),
      { enabled: true, name: "useInsuranceStore" }
    )
  )
);

export default useInsuranceStore;
